__webpack_require__.p = "https://platform.arealtimetech.com/";